export default __webpack_public_path__ + "static/media/Mario McRlwain.27bdf55c.jpg";